<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-25 10:29:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-27 17:55:51
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/promoteGoods/promonteGoodsList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="promont-goods-list main-content-padding">
		<Panel :contentPaddingTop="16">
			<BreadCrumb slot="header"></BreadCrumb>
			<search @search="onSearch" />
		</Panel>
		<Panel :contentPadding="24" v-loading="loading">
			<multi-table class="table-base" :total="total" :page="pageInfo" :list="data" :columns="columns" @gePartnerList="pageCallbackList">
				<Empty ref="empty" slot="empty"></Empty>
			</multi-table>
		</Panel>
	</div>
</template>
<script>
import search from './search.vue';
import { columns } from './columns';
import { applyProductList } from '@/api/shopManage';
export default {
	components: {
		search,
		
	},
	data() {
		return {
			columns,
			data: [],
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,
			loading: false,
		};
	},
	computed: {
		platformId() {
			return this.$route.query.platformId || '';
		},
	},
	methods: {
		async getList(search) {
			try {
				this.loading = true;
				const { data } = await applyProductList({ ...search, ...this.pageInfo, platformId: this.platformId });
				this.total = data.total;
				this.data = data.list;
			} finally {
				this.loading = false;
			}
		},
		pageCallbackList(obj){
			const { page_size, page_index } = obj
			this.pageInfo.page_size = page_size;
			this.pageInfo.page_index = page_index;
			this.getList();
		},
		onSearch(search){
			this.pageInfo.page_index = 1;
			this.getList(search)
		}
	}
};
</script>
<style lang="less" scoped>
.table-base{
	/deep/ tr:hover{
		.copy-wrapper{
			opacity: 1 !important;
		}
	}
}
</style>
